export const getFileNameByPath = (path: string): string => {
    return path.split('/').pop()!
}

export const downloadFile = async (path: string) => {
    const response = await fetch(path, {
        method: 'GET',
    })

    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    const downloadedFile = document.createElement('a')
    downloadedFile.href = url
    downloadedFile.download = `${getFileNameByPath(path)}`
    document.body.appendChild(downloadedFile)
    downloadedFile.click()
    document.body.removeChild(downloadedFile)
    window.URL.revokeObjectURL(url)
}
